import { defineComponent } from "vue";
import { AppStringMethods } from 'src/plugins/string/stringMethods';
import { useViewStore } from 'src/stores/view';
/**
 * Individual drawer options
 */
export default defineComponent({
    props: {
        additionalData: {
            type: Object,
        },
        badgeCount: {
            type: Number,
            default: 0,
        },
        icon: {
            type: String,
            required: true,
        },
        iconRight: Boolean,
        iconSize: {
            type: String,
            default: "1.1rem",
        },
        showSeparator: Boolean,
        title: {
            type: String,
            required: true,
        },
    },
    emits: ["click"],
    setup(props, context) {
        const { combineStringWithDelimiter } = AppStringMethods();
        const viewStore = useViewStore();
        function clickEmit() {
            console.log('14');
            viewStore.toggleDrawer(false);
            context.emit('click');
        }
        return { combineStringWithDelimiter, clickEmit };
    }
});
